<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
	  <z-page :title="title">
      <w-form class="" v-model="form.valid" v-model:errors-count="form.errorsCount" @validate="onValidate" @success="onSuccess()" >
        <div class="w-flex wrap smd-column" >
          <div class="grow " >
            <!-- {{se_pengeluaran}} -->
            <w-input class="mt4" label="Tarikh Pendaftaran*" type="date" v-model="form.tarikh" :validators="[validators.required]"/>
            <!-- <template v-if="form.id == 0"> -->
               <z-select class="mt4" :items="se_pengeluaran" @input="pilihNoBatch" label="No Batch *"  v-model="form.se_pemungutan_id" :validators="[validators.required]"/>
            <!-- </template> -->
            
            <div class="spacer"></div>
            <br>
            <w-input label="Nama & Negara Pengeluaran Semen" v-model="form.negara" readonly/>
            <div class="spacer"></div>
            <br>
            <w-input label="ID Ternakan" v-model="form.id_ternakan" readonly/>
            <div class="spacer"></div>
            <br>
            <w-input label="Nama Ternakan" v-model="form.nama_ternakan" readonly/>
            <div class="spacer"></div>
            <br>
            <w-input label="Baka" v-model="form.baka" readonly/>
            <div class="spacer"></div>
            <br>
            <w-input label="Tarikh Pengeluaran" type="date" v-model="form.tarikh_pengeluaran" readonly/>
            <div class="spacer"></div>
            <br>
            <w-input label="Bilangan Straw Dikeluarkan" type="number" v-model="form.bil_straw"/>
            <br>
            <w-input label="Bilangan Straw Didaftarkan*" type="number" v-model="form.baki" :max="form.bil_straw" @keyup="baki()" :validators="[validators.required]"/>
            <br>
            <z-money class="mt4" label="Harga Perstraw (RM) *" v-model:originalValue="form.harga" :validators="[validators.required]"/>
          </div>
          
        </div>
        <w-flex class="mt3" wrap align-center justify-end v-if="$zutil.anyRole(['1', '3', '11'])">
         <!-- <w-tooltip md top color="white" bg-color="black" >
                <template #activator="{ on }">
                      <w-button class="my1" v-on="on"  :loading="form.submitted && !form.sent" @click="send(2); onSuccess()"><div style="width: 6px"></div> 
                    <w-icon class="mr1" md >fal fa-save</w-icon>
                </w-button>
                </template>
               SIMPAN
            </w-tooltip> -->
            <w-button class="my1"   :loading="form.submitted && !form.sent" @click="send(2); onSuccess()">
          <w-icon dark tile class="mr2">fal fa-save</w-icon> SIMPAN
        </w-button>
            &nbsp;
            <!-- <w-tooltip md top color="white" bg-color="black" >
                <template #activator="{ on }">
                      <w-button class="my1" v-on="on" bg-color="success" type="submit" :disabled="form.valid === false" :loading="form.submitted && !form.sent" @click="send(1)"><div style="width: 6px"></div> 
                    <w-icon class="mr1" md >fal fa-paper-plane</w-icon>
                </w-button>
                </template>
               HANTAR
            </w-tooltip> -->
            <w-button class="my1" bg-color="success" type="submit" :disabled="form.valid === false" :loading="form.submitted && !form.sent" @click="send(1)">
          <w-icon xs class="mr2">fal fa-paper-plane</w-icon> HANTAR
        </w-button>

        </w-flex>
        <div class="mt2 text-left">
        <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 11px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="tutup">TUTUP</w-button>&nbsp;
      </div>
      </w-form>
	  </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'



export default {
  extends: ZResource,
  props: {
    d_form: [Array, Object],
    d_se_pengeluaran : [Array, Object],
  },
  data() {
    return {
      resourceurl: 'se.pendaftaran',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Pengurusan Semen Beku', route: '/se' },
        { label: ' Pendaftaran Semen IBVK', route: '/se/pengeluaran' },
      ],
      title : ' Pendaftaran Semen IBVK',
      form : this.d_form,
      se_pengeluaran : this.d_se_pengeluaran,
      
    }
  },
  methods: {
   baki(){
      if(this.form.baki > this.form.bil_straw){
         this.form.baki = this.form.bil_straw;
      }
   },
   pilihNoBatch(value){
      for (var i in this.se_pengeluaran) {
         if (this.form.se_pemungutan_id == this.se_pengeluaran[i].value) {
            this.form.negara = 'IBVK Malaysia';
            this.form.no_batch = this.se_pengeluaran[i].no_batch;
            this.form.id_ternakan = this.se_pengeluaran[i].id_ternakan;
            this.form.nama_ternakan = this.se_pengeluaran[i].nama_ternakan;
            this.form.baka = this.se_pengeluaran[i].baka;
            this.form.tarikh_pengeluaran = this.se_pengeluaran[i].tarikh_pengeluaran;
            this.form.bil_straw = this.se_pengeluaran[i].jumlah_pengeluaran;
         }
      }
      // alert('asd');
   },
    send(hantar){
      this.form.hantar = hantar
    },

    tutup(){
         this.$inertia.visit(window.route('se.pendaftaran.index'));
       },

    onSuccess(){
      if(this.form.hantar == 1){
        this.$swal({
            title: 'Anda Pasti?',
            // text: "Are you sure want to delete this item!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya',
            cancelButtonText: 'Tidak'
          }).then((result) => {
            if (result.value) {
              if (this.form.id > 0){
                this.$zcomm.update(this.resourceurl + '.update', this.form.id, this.form)
                .then(res => {
                  if (typeof this.onAfterEdit === "function") {
                    this.onAfterEdit()
                  }
                  if (this.form.hantar==1) {
                      this.$inertia.visit(this.$route('se.pendaftaran.show', this.form.id));
                  }else{
                      this.$zutil.notify("Berjaya disimpan", true);
                  }
                  // this.$inertia.visit(this.$route('se.pemungutan.show', this.form.id))
                })
              }else{
                this.$zcomm.post(this.resourceurl+'.store' , this.form)
                .then(res => {
                  if (typeof this.onAfterAdd === "function") {
                    this.onAfterAdd()
                  }
                  this.$zutil.notify("Berjaya dihantar", true);
                  this.$inertia.visit(window.route('se.pendaftaran.show',res.id));

                })
              }
            }
          })
      }else{
        if (this.form.id > 0) 
        {
          
          this.$zcomm.update(this.resourceurl + '.update', this.form.id, this.form)
          .then(res => {
            if (typeof this.onAfterEdit === "function") {
              this.onAfterEdit()
            }
            if (this.form.hantar==1) {
                this.$inertia.visit(this.$route('se.pendaftaran.show', this.form.id));
            }else{
                this.$zutil.notify("Berjaya disimpan", true);
                this.$inertia.visit(this.$route('se.pendaftaran.form', this.form.id));
            }
            // this.$inertia.visit(this.$route('se.pemungutan.show', this.form.id))
          })
        }
        else 
        {
          this.$zcomm.post(this.resourceurl+'.store' , this.form)
          .then(res => {
            if (typeof this.onAfterAdd === "function") {
              this.onAfterAdd()
            }
            this.$zutil.notify("Berjaya disimpan", true);
            this.$inertia.visit(this.$route('se.pendaftaran.form', res.id));
            // this.$inertia.visit(this.$route('se.pemungutan.show', res.id))

          })
        }
      } 
      
    },


    
  
  },

  watch: {

  },
  mounted() {
    if (this.form.id == 0) {
      var today = new Date();
       this.form.tarikh = today.toISOString().split('T')[0];
    }
    if(this.form.id > 0)
    {
      this.title = 'Kemaskini Pendaftaran Semen IBVK'
    }
    else
    {
      this.title = 'Tambah Pendaftaran Semen IBVK'
    }
   
    
  }
    
}
</script>
